// import { canUseDOM } from 'exenv';

export function giftGuideDetailLoading(resp = {}, store = {}) {
  return {
    type: 'GIFT_GUIDE_DETAIL_LOADING',
    giftGuideDetail: resp,
    store
  };
}

export function giftGuideDetailLoaded(resp = {}, store = {}, year) {
  return {
    type: 'GIFT_GUIDE_DETAIL_LOADED',
    giftGuideDetail: resp,
    store,
    year
  };
}

export function giftGuideDetailLoadError(error, store = {}) {
  return {
    type: 'GIFT_GUIDE_DETAIL_ERROR',
    giftGuideDetail: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
